import { rest } from '@0xtorch/core'
import { z } from 'zod'
import { createSha256Hash } from '../../utils/createSha256Hash'
import { fetchAllData } from '../../utils/fetchAllData'
import { binanceApiEndpoint } from '../constants'
import type { Withdraw } from './schema'
import { withdrawSchema } from './schema'

const responseSchema = z.array(withdrawSchema)

type FetchAllWithdrawHistoriesParameters = {
  readonly apiKey: string
  readonly apiSecret: string
  readonly from: number
  readonly to: number
  readonly proxy?: string
}

const urlPath = '/sapi/v1/capital/withdraw/history'

export const fetchAllWithdrawHistories = ({
  apiKey,
  apiSecret,
  from,
  to,
  proxy,
}: FetchAllWithdrawHistoriesParameters): Promise<readonly Withdraw[]> =>
  fetchAllData({
    from,
    to,
    limit: 1000,
    desc: true,
    idKey: 'id',
    timestampKey: 'applyTime',
    interval: 150,
    fetchData: async ({ from, to, limit, desc }) => {
      if (!desc) {
        throw new Error('desc must be true')
      }
      if (limit > 1000) {
        throw new Error('limit must be less than or equal to 1000')
      }

      const url = new URL(urlPath, binanceApiEndpoint)
      url.searchParams.append('status', '6')
      url.searchParams.append('timestamp', Date.now().toString())
      url.searchParams.append('limit', limit.toString())
      if (from !== undefined) {
        url.searchParams.append('startTime', from.toString())
      }
      if (to !== undefined) {
        url.searchParams.append('endTime', to.toString())
      }
      url.searchParams.append(
        'signature',
        await createSha256Hash(url.searchParams.toString(), apiSecret),
      )

      const response = await rest(
        proxy === undefined
          ? url.toString()
          : `${proxy}${encodeURIComponent(url.toString())}`,
        {
          fetchOptions: {
            method: 'GET',
            headers: {
              'X-MBX-APIKEY': apiKey,
            },
          },
          schema: responseSchema,
        },
      )

      return response
    },
  })
